import React from "react";
import { withStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Input from "@material-ui/core/Input";
import ColourChip from "./ColourChip";
import { GetColourArray } from "./Common";

// Redux Actions
import { connect } from "react-redux";
const mapStateToProps = (state) => ({
    config: {
        colour_arrays: state.config.colour_arrays,
    },
});

// QQ3DWebGL.propTypes = {
//     classes: PropTypes.object.isRequired,
// };

const styles = {
    focused: {
        color: "orange !important",
    },
    select: {
        color: "white",
        focused: {
            color: "orange",
        },
    },
    selectBlack: {
        color: "black",
        focused: {
            color: "#AB6300",
        },
    },
    underline: {
        borderBottomColor: "orange",
        "&:after": {
            // The MUI source seems to use this but it doesn't work
            borderBottomColor: "orange",
        },
        "&:before": {
            // The MUI source seems to use this but it doesn't work
            borderBottom: "none",
        },
    },
    orangeText: {
        color: "orange !important",
    },
    whiteText: {
        color: "white",
        // focused: {
        //     fontSize: '10px',
        //     color: 'orange',
        // }
    },
    blackText: {
        color: "black",
        "&:focus": {
            fontSize: "10px",
            color: "#515152",
        },
    },
    disabled: {
        color: "grey !important",
        "&::before": {
            border: "none !important",
        },
    },
};

function ColourSelector(props) {
    const {
        classes,
        style,
        config,
        dark,
        width,
        undecided,
        defaultColour,
        useUndecided = false,
        colourMatch,
        reverseColours = false,
    } = props;

    // let colourlist = "Colorbond";
    // if (props.selectedItem && props.selectedItem.GroupingName === "Beams") colourlist = "CentenaryBeam";
    // let double_sided = true;
    // if (props.selectedItem) double_sided = props.selectedItem.ProductCode.includes("**H**") || props.selectedItem.ProductCode.includes("****")
    // let desc = "";
    // if (props.selectedItem) desc = props.selectedItem.ProductDescription
    // let colour_options = setup_editor_colour_selector(props.colourList, props.doubleSided, desc);

    let selectedColour = props.value;
    if (undecided) selectedColour = "TBA";

    let colour_options = [];
    let colours = GetColourArray(props.colourList, config.colour_arrays);
    // 
    if (colours !== []) {
        if (colours.length > 1 && useUndecided) {
            if (defaultColour !== null)
                colour_options.push(
                    <MenuItem key={"TBA"} data-defaultcolour={defaultColour} value="TBA">
                        <ColourChip colour={defaultColour} width="2rem" />
                        &nbsp;UNDECIDED
                    </MenuItem>
                );
            else
                colour_options.push(
                    <MenuItem key={"TBA"} value="TBA">
                        UNDECIDED
                    </MenuItem>
                );
        }
        for (var colour of colours) {
            let colour_trim = colour.trim();
            let display_colour = colour_trim;
            let display_text = colour_trim;

            if (colourMatch && colour_trim in colourMatch) {
                display_colour = colourMatch[colour_trim];
                display_text = colour_trim + " (" + colourMatch[colour_trim] + ")";
            }

            // let reverse_colour = false;
            // if (reverseSingleSidedColours && colour_trim.includes("/Grey")) reverse_colour = true;
            colour_options.push(
                <MenuItem key={colour_trim} value={colour_trim}>
                    <ColourChip colour={display_colour} reverse={reverseColours} width="2rem" />
                    &nbsp;{display_text}
                </MenuItem>
            );
        }

        if (!colours.includes(selectedColour) && colours.includes(selectedColour + "/Grey")) {
            selectedColour = selectedColour + "/Grey";
        }
    }
    // else {

    //     if (props.colourList.length > 1 && useUndecided) {
    //         if (defaultColour !== null) colour_options.push(<MenuItem key={"TBA"} data-defaultcolour={defaultColour} value="TBA"><ColourChip colour={defaultColour} width="2rem" />&nbsp;UNDECIDED</MenuItem>);
    //         else colour_options.push(<MenuItem key={"TBA"} value="TBA">UNDECIDED</MenuItem>);
    //     }

    //     for (var key in props.colourList) {
    //         if (props.colourList.hasOwnProperty(key)) {
    //             // 
    //             if (!props.allowDoubleSided && key.includes("/")) { }
    //             else colour_options.push(<MenuItem key={key} value={key}><ColourChip colour={key} width="2rem" />&nbsp;{key}</MenuItem>);
    //         }
    //     }
    // }

    return (
        <FormControl style={style ? style : { width: width, textAlign: "left" }}>
            {props.text && (
                <InputLabel
                    htmlFor={props.id}
                    shrink={true}
                    className={dark ? classes.blackText : classes.whiteText}
                    disabled={props.disabled}
                    // FormLabelClasses={classes}
                    classes={{
                        root: classes.whiteText,
                        focused: classes.orangeText,
                        disabled: classes.disabled,
                    }}
                    // color="secondary"
                >
                    {props.text}
                </InputLabel>
            )}
            <Select
                value={selectedColour}
                className={dark ? classes.selectBlack : classes.select}
                onChange={props.onChange}
                disabled={props.disabled}
                name="Colour"
                input={
                    <Input
                        classes={{
                            focused: classes.orangeText,
                            underline: classes.underline,
                            disabled: classes.disabled,
                        }}
                        name={props.id}
                        id={props.id}
                    />
                }
                // classes={{label: classes.whiteText, labelFocussed: classes.whiteText}}
            >
                {colour_options}
            </Select>
            {/* <FormHelperText>Some important helper text</FormHelperText> */}
        </FormControl>
    );
}

// function setup_editor_colour_selector(list_name = "Colorbond", double_sided_allowed = true, desc = null) {

//     let options = [];
//     if (desc) {
//         let colour = $.get_colour_from_desc(desc, null);
//         if (colour) return [<MenuItem value={colour}><BOMListItemColourChip colour={key} width="2rem" /> {colour}</MenuItem>]
//     }

//     var list = $.Colorbond_Colours;
//     if (list_name === "CentenaryBeam") list = $.Centenary_Beam_Colours;

//     options.push(<MenuItem value=""></MenuItem>);

//     for (var key in list) {
//         if (list.hasOwnProperty(key)) {
//             // 
//             if (!double_sided_allowed && key.includes("/")) { }
//             else options.push(<MenuItem value={key}><BOMListItemColourChip colour={key} width="2rem" /> {key}</MenuItem>);
//         }
//     }
//     return options;
// }

export default connect(mapStateToProps, null)(withStyles(styles)(ColourSelector));
